<template>
  <div
    class="market_research_notification items-start"
    :class="{ unseen: !isRead }"
  >
    <ThemeImage
      :icon="imageNames.SUPER_AGI_LOGO_ROUND"
      alt="icon"
      class="notification_icon"
    />
    <div class="flex flex-col gap-[6px] flex-grow min-w-0">
      <span class="proxima_nova text-sm font-normal text_color">
        <span class="font-bold break-words content-wrapper"
          >Outreach reply received</span
        >
      </span>
      <div v-if="entityType" class="flex flex-row items-center">
        <span class="proxima_nova text-xs font-semibold text_color">{{
          entityName
        }}</span>
      </div>

      <div class="secondary_color text-xs text-nowrap">
        {{ formatTimestamp(createdTime, "timestamp", formatTypes.centered) }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { formatTimestamp } from "@/src/utils/dateTimeUtils.js";
import { formatTypes } from "@/src/constants/dateTimeConstants.js";
import sidebarImagePath from "@/src/paths/sidebarImagePath.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  entityType: {
    type: String,
    default: null,
  },
  entityName: {
    type: String,
    default: null,
  },
  createdTime: {
    type: String,
    required: true,
  },
  isRead: {
    type: Boolean,
    required: true,
  },
});

const entityIconMap = {
  company: imageNames.COMPANIES_UNSELECTED,
  contact: imageNames.CONTACTS_UNSELECTED,
};

const entityIcon = computed(() => {
  const entityType = props.entityType?.toLowerCase() || "";
  return entityIconMap[entityType] || imageNames.CONTACTS_UNSELECTED;
});
</script>

<style scoped>
.market_research_notification {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  border-radius: 8px;
}

.market_research_notification.unseen {
  border-radius: 8px;
  background: rgba(112, 149, 235, 0.12);
}

.market_research_notification:hover {
  background-color: var(--white-opacity-8);
}

.market_research_notification.unseen:hover {
  background:
    linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.08) 0%,
      rgba(255, 255, 255, 0.08) 100%
    ),
    rgba(112, 149, 235, 0.12);
}

.truncate_content {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
